module.exports = __webpack_public_path__ + "static/media/chaindrive.ca9413ef.png";